import classNames from "classnames"

import styles from "./BolusEventModal.module.scss"
import type { BolusEventProps } from "./BolusEventProps"
import { useBolusInformationValue } from "./useBolusInformationValue"
import { usePolyglot } from "src/contexts"
import type { BolusInformation } from "src/types"

const prefix = "components.event_modal.bolus.label."

interface Props extends BolusEventProps {
  bolusInfo: BolusInformation;
}

export function BolusSubItem(props: Props) {
  const {
    bolusInfo,
    userEvent,
  } = props
  const polyglot = usePolyglot()

  const bolusInfoLabelKey = `${prefix}${bolusInfo}`

  const label = polyglot.has(bolusInfoLabelKey)
    ? polyglot.t(bolusInfoLabelKey)
    : null

  const value = useBolusInformationValue(
    bolusInfo,
    userEvent,
  )

  if (!value || !label) {
    return null
  }

  return (
    <>
      <div className={styles.row}>
        <span
          className={classNames(
            styles.textMediumRegular,
            styles.keyText,
          )}
        >
          {label}
        </span>
        <span className={styles.textMediumRegular}>
          {value}
        </span>
      </div>
      <div className={styles.separator} />
    </>
  )
}
